import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import ServicesHero from '../components/ServicesHero';
import WhatWeDo from '../components/WhatWeDo';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="Electrical & Security Services Bayside Melbourne"
        description="Full-service electrical and security solutions in Carrum and Bayside Melbourne. CCTV, alarms, EV chargers, switchboards and more. Get a free quote."
        keywords="electrical services Bayside Melbourne, security services Carrum, CCTV installation, alarm systems, EV charger installation, switchboard upgrades"
        canonical="https://securelec.net.au/what-we-do"
      />
      <Header />
      <main>
        <ServicesHero />
        <WhatWeDo />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
